import type {
  FormattedGameMode,
  GameModesResponse
} from '@library/types/gameModes';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';
import { transformGameModes } from '@bo-utils/gameModes';

const { admin } = apiPaths;

export const rolesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getGameModes: build.query<Array<FormattedGameMode>, void>({
      query: () => ({
        url: `${admin}game_modes`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformResponse: (response: GameModesResponse | undefined) =>
        transformGameModes(response),
      providesTags: ['GameModes']
    })
  })
});

export const { useGetGameModesQuery } = rolesApi;
